import React from 'react';
import cx from 'classnames';
import { Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { THEME } from '../../config/commons';
import Icon from '../../common/components/Icon/Icon';

import styles from './SwitchTheme.module.scss';
import { Store } from '../../state/store.interface';
import { setTheme } from '../Analysis-Detail/detailAnalysisSlice';

interface Props {
  size?: 'small' | 'default';
  showBoxShadow?: boolean;
  isAnalysisPublic?: boolean;
}

export const SwitchTheme = (props: Props) => {
  const { size = 'small', showBoxShadow = false, isAnalysisPublic = false } = props;
  
  const dispatch = useDispatch();
  const { theme } = useSelector((state: Store) => state.detail);
  const isDarkTheme = theme === THEME.DARK;

  const onChangeTheme = () => {
    let newTheme: THEME;

    switch (theme) {
      case THEME.DARK:
      default:
        newTheme = THEME.LIGHT;
        break;

      case THEME.LIGHT:
        newTheme = THEME.DARK;
        break;
    }

    localStorage.setItem('theme', newTheme);
    dispatch(setTheme(newTheme));
  };

  return (
    <div className={cx(styles.container)}>
      <Switch
        className={cx(isAnalysisPublic && isDarkTheme ? styles.switchDarkAnalysisPublic : '', isDarkTheme ? styles.switchDark : styles.switchLight, showBoxShadow ? styles.boxShadow : '')}
        checkedChildren={<Icon className={styles.icon} name='moon' type='fill' />}
        unCheckedChildren={<Icon className={styles.icon} name='sun' type='fill' />}
        defaultChecked={isDarkTheme}
        checked={isDarkTheme}
        onChange={onChangeTheme}
        size={size}
      />
    </div>
  );
};
